import { forwardRef } from 'react';

import { TProps } from '../types/TProps';
import { NeutralButtonChrome } from './NeutralButtonChrome';

export const FileIconLinkButton = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <NeutralButtonChrome ref={ref} className={['btn--file-link', className].filter(Boolean).join(' ')} {...props} />
));

FileIconLinkButton.displayName = 'FileIconLinkButton';
